import { log } from '@ali/re-utils';
import { parseFunc } from './parser';

export default class Action {
  constructor(options) {
    const { title, id, func } = options;

    this.func = parseFunc(func);

    if (title && id) {
      this.description = `${title}(${id})`;
    } else if (title) {
      this.description = title;
    } else if (id) {
      this.description = `(${id})`;
    } else {
      this.description = 'anonymous';
    }
  }

  invoke(context, args = []) {
    log(
      `%cRun Action: %c${this.description}`,
      'color:#000;font-weight:bold;',
      'color:green;font-weight:bold;',
      context
    );
    return this.func.apply(context, args);
  }
}
